module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-full-calendar"
  }, _vm._l((_vm.totalMonths), function(n) {
    return _c('Month', {
      key: n,
      attrs: {
        "current-date": _vm.setMonth(n),
        "events": _vm.events,
        "isHolidaysCalendar": _vm.isHolidaysCalendar
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ced0860a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./src/components/Calendar/Calendar.pug
// module id = 191
// module chunks = 1